import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditMeetingPayload } from '@app-store/slices/meetings/editMeeting'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditMeetingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.edit

function* editMeetingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/meeting/${payload.meetingId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Meeting updated successfully.'
            })
            if (payload.sagaCB) {
                yield put(payload.sagaCB.onSuccess(response.result))
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editMeetingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editMeetingSagaTask)
}

export default editMeetingSaga
